import { CustomFieldStructure, FieldStructure, InputFieldStructure } from '@mercell/form-react';
import { FormDefinitionItem } from '../../types/generated/formDefinitionItem';
import { getRulesSetup } from '../getRulesSetup';
import * as yup from 'yup';
import { TFunction } from 'react-i18next';
import {
    normalizeNumberString,
    formatNumberForLocale,
    createNumericFieldRender,
} from './numericFieldUtils';

const parseToNumber = (value: string): number | null => {
    const normalized = normalizeNumberString(value);
    if (normalized === '') {
        return null;
    }
    const parsed = parseFloat(normalized);
    return Number.isNaN(parsed) ? null : parsed;
};

const formatForEditing = (value: number | null | undefined): string => {
    if (value === null || value === undefined) {
        return '';
    }
    if (typeof value === 'string') {
        return value;
    }
    return value.toString();
};

export const mapNumberField = (
    formDefinition: FormDefinitionItem,
    genericFieldStructure: FieldStructure,
    t: TFunction<string, unknown>,
    language?: string,
    enableNumericFormatting?: boolean
): InputFieldStructure | CustomFieldStructure => {
    const locale = language ?? 'en-GB';

    if (genericFieldStructure.associatedValidationBasedOnOtherFieldValues) {
        if (
            formDefinition.conditionalValidation?.rules &&
            genericFieldStructure.associatedValidationBasedOnOtherFieldValues
        ) {
            const conditionalValidations = getRulesSetup(
                yup.number().nullable(),
                formDefinition.conditionalValidation.rules,
                t
            );
            genericFieldStructure.associatedValidationBasedOnOtherFieldValues.rules =
                conditionalValidations;
        }
    }

    const validations = formDefinition.rules
        ? getRulesSetup(yup.number().nullable(), formDefinition.rules, t)
        : undefined;

    // When feature flag is disabled, use standard number type
    if (!enableNumericFormatting) {
        return {
            ...genericFieldStructure,
            type: 'number',
            validations,
        };
    }

    return {
        ...genericFieldStructure,
        type: 'custom',
        render: createNumericFieldRender({
            locale,
            genericFieldStructure,
            parseValue: parseToNumber,
            formatForEditing,
        }),
        validations,
    } as CustomFieldStructure;
};

export const mapNumberReadOnly = (
    content: any,
    language: string,
    enableNumericFormatting?: boolean
) => {
    if (!enableNumericFormatting) {
        return Number(content).toLocaleString(language);
    }
    return formatNumberForLocale(Number(content), language);
};
